export default __webpack_public_path__ + "static/media/solseaLogo.353f25da.svg";